/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type MembershipRecurrenceType = 0 | 1 | 2 | 3 | 6 | 12;

export const MembershipRecurrenceType = {
    NUMBER_0: 0 as MembershipRecurrenceType,
    NUMBER_1: 1 as MembershipRecurrenceType,
    NUMBER_2: 2 as MembershipRecurrenceType,
    NUMBER_3: 3 as MembershipRecurrenceType,
    NUMBER_6: 6 as MembershipRecurrenceType,
    NUMBER_12: 12 as MembershipRecurrenceType
}